import { ShapeData, ShapeFrameData } from 'data/FlyerData';
import { FrameType } from 'data/FrameType';
import { ShapeFrame } from 'data/ShapeFrame';
import { getOverlayColor } from 'state/actions';
import { getLayerById } from 'state/FlyerState';
import RootState from 'state/RootState';
import { AddFrameCommand } from './AddFrameCommand';
import { CommandFunction } from './Command';

export class AddShapeFrameCommand extends AddFrameCommand {
  dataAsString: string;
  constructor(layerId: string | undefined, data: ShapeData) {
    super(layerId);
    this.dataAsString = JSON.stringify(data);
  }

  execute(firstTime?: boolean): CommandFunction {
    return async (dispatch: Function, getState: () => RootState) => {
      const { app, flyer } = getState();
      const layer = getLayerById(flyer, this.layerId);
      const { resolution } = flyer;
      const { width, height } = resolution;
      const overlayColor = getOverlayColor(resolution, layer);
      const mask = JSON.parse(this.dataAsString) as ShapeData;
      let shapeData: ShapeFrameData = {
        type: FrameType.Shape,
        mask,
        colors: Array.isArray(overlayColor) ? overlayColor : [overlayColor]
      };
      const frame = new ShapeFrame(width, height);
      frame.populateWithData(shapeData);
      await frame.load();
      frame.hasBeenEdited = false;
      this.dispatchWithFrame(
        dispatch,
        frame,
        layer,
        app.openedModals.length > 0,
        firstTime
      );
    };
  }
}



// WEBPACK FOOTER //
// ./src/state/commands/AddShapeFrameCommand.ts